import { createContext } from 'react'

const AgDataGridThemeContext = createContext({})

export default AgDataGridThemeContext
